<template>
  <div class="i-backup-status-dropdown">
    <i-dropdown
      :label="label"
      v-model="value"
      :options="options"
      placeholder="All"
      :allow-empty="false"
      @input="onInput"
    />
  </div>
</template>

<script>
import i18n from "@/boot/i18n";
import IDropdown from "@/components/common/IDropdown.vue";

export default {
  name: "IBackupStatusDropdown",
  emits: ['input'],
  components: {IDropdown},

  data() {
    return {
      options: [
        {label: this.$t('recovery.statusOptions.all'), value: ''},
        {label: this.$t('recovery.statusOptions.pending'), value: 1},
        {label: this.$t('recovery.statusOptions.inProgress'), value: 2},
        {label: this.$t('recovery.statusOptions.completed'), value: 3},
        {label: this.$t('recovery.statusOptions.failed'), value: 4},
      ],
      value: '',
    }
  },

  props: {
    label: {
      type: String,
      default() {
        return i18n.global.t('common.statusUpperCase');
      }
    },
  },

  methods: {
    onInput(e) {
      this.$emit('input', e);
    },
  },
}
</script>

<style lang="scss">
@import "IBackupStatusDropdown";
</style>
